/**
 * 数科-臻有钱首页-主按钮角标 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 * 广告位信息
 * 名称:数科-臻有钱首页-按钮角标
 * uuid:44b816310e4842ecaafc974722cc7f0a
 */
import { Vue, Component, Prop } from 'vue-property-decorator';
import AdvCommonContainer from '../adv-common-container';

import style from './index.module.scss';

@Component
export default class AdvHomeCornerMark extends Vue {
  /**
   * 是否传入自定义样式
  */
  @Prop(String)
  private customClassName?: string;

  private render() {
    return (
      <AdvCommonContainer
        advMasterId="44b816310e4842ecaafc974722cc7f0a"
        customClassName={this.customClassName || style.homeCornerMark}
      />
    );
  }
}
